import * as React from 'react';

import { trackHowItsWorkClick } from './tracking';
import { MainButtons } from '../../components/MainButtons';
import { useTrackingParams } from '../../hooks/useTrackingParams';
import { EScrollingBlocks } from '../../types/page/scrolling';
import { useScrollToBlock } from '../Scrolling/hooks';
import { ShareButtonContainer } from '../ShareButtonContainer';
import { useGetShareButtonText } from '../../hooks/useGetShareButtonText';

export const MainButtonsContainer: React.FC = () => {
  const scrollToBlock = useScrollToBlock();
  const { siteType, dealType, cianSource } = useTrackingParams();
  const shareButtonText = useGetShareButtonText();

  const scrollToHowItWork = React.useCallback(() => {
    scrollToBlock(EScrollingBlocks.HowItWork);
    trackHowItsWorkClick({
      siteType,
      dealType,
      cianSource,
    });
  }, [scrollToBlock]);

  return (
    <MainButtons
      scrollToHowItWork={scrollToHowItWork}
      shareButton={<ShareButtonContainer />}
      shareButtonText={shareButtonText}
    />
  );
};

MainButtonsContainer.displayName = 'MainButtonsContainer';
